import axios from "../../config/interceptor";
import moment from "moment";
import { postPatient } from "../PatientService";
import { postUseActivePackage } from "./PackageService";
import { postStartVisitV2, postEndVisit } from "../AssesmentService";
import { postUseActiveDeposit } from "./DepositService";

export const postEndToStartVisitReservation = async (data) => {
  try {
    const responseEndVisit = await endVisitReservation({
      ...data.previousReservation,
      status: "DONE",
      note: null,
      fileUrl: null,
    });
    if (responseEndVisit.status === 200) {
      const responseStartVisit = await postStartVisitReservation(
        data.newReservation
      );

      return responseStartVisit;
    }
    return responseEndVisit;
  } catch (error) {
    return error;
  }
};

export const postEndVisitReservation = async (data) => {
  try {
    const responsePost = await postEndVisit(data);

    if (responsePost.status === 200) {
      const responseUpdate = await updateReservation({
        booking_id: data.bookingId,
        patient_id: data.patientId,
        status: "DONE",
      });

      return responseUpdate;
    }

    return responsePost;
  } catch (error) {
    return error;
  }
};

export const postStartVisitReservation = async (data) => {
  try {
    const responsePost = await postStartVisitV2({ ...data, bookingId: null });

    if (responsePost.status === 200) {
      if (!data.bookingId) {
        const responseReservation = await postBookingReservation({
          ...data.reservation,
          patientId: responsePost?.data?.patientId || data.patientId,
          visitId: responsePost?.data?.visitId,
          locationId: data.locationId,
        });
        return responseReservation;
      } else {
        const responseUpdate = await updateReservation({
          booking_id: data.bookingId,
          patient_id: responsePost?.data?.patientId || data.patientId,
          location_id: data.locationId,
          visit_id: responsePost?.data?.visitId,
          status: "ACTIVE",
        });

        let packagePaymentId = data.paymentId || null; // Default to provided payment ID

        // Handle packages first to get payment ID
        if (data?.packages?.length > 0) {
          const packagePromises = data.packages.map((item) => {
            const dataPackage = {
              patientId: responsePost?.data?.patientId || data.patientId,
              bookingId: data.bookingId,
              packageId: item,
              paymentId: data.paymentId,
              businessId: data.businessId,
              createdBy: data?.createdBy,
              updatedBy: data?.updatedBy,
              createdById: data?.createdById,
            };
            return postUseActivePackage(dataPackage);
          });

          const packageResults = await Promise.all(packagePromises);

          // Get payment ID from the first successful package response
          if (packageResults.length > 0 && packageResults[0].status === 200) {
            packagePaymentId =
              packageResults[0].data?.data?.paymentId || data.paymentId;
          }
        }

        // Handle deposits using the payment ID from packages
        if (data?.deposits?.length > 0) {
          const depositPromises = data.deposits.map((depositId) => {
            const dataDeposit = {
              patientId: responsePost?.data?.patientId || data.patientId,
              bookingId: data.bookingId,
              depositId: depositId,
              paymentId: packagePaymentId,
              businessId: data.businessId,
              createdBy: data?.createdBy,
              updatedBy: data?.updatedBy,
              createdById: data?.createdById,
            };
            return postUseActiveDeposit(dataDeposit);
          });

          await Promise.all(depositPromises);
        }

        return responseUpdate;
      }
    }

    return responsePost;
  } catch (error) {
    return error;
  }
};

export const postBookingReservation = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/save-reservation`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const postNewPatientReservation = async (data) => {
  try {
    const alergiesDTOs = data.allergies.map((item) => ({
      ...item,
      ...(item.__isNew__ ? {} : { __isNew__: false }),
    }));
    const dataSavePatient = {
      email: data.email,
      name: data.name,
      phoneNumber: data.phoneNumber,
      gender: data.gender,
      address: data.address,
      remark: data.remark,
      identificationType: data.identificationType,
      identificationNumber: data.identificationNumber,
      medicalRecordNumber: data.medicalRecordNumber,
      dateOfBirth: data.dateOfBirth || null,
      dob: data.dateOfBirth || null,
      allergy: alergiesDTOs,
    };

    const response = await postPatient(dataSavePatient);

    if (response.status === 200) {
      if (!!data?.isUpdate) {
        const dataUpdateReservation = {
          booking_id: data?.booking_id || null,
          patient_id: response.data.id,
          location_id: data?.locationId || "",
        };

        const responseUpdate = await updateReservation(dataUpdateReservation);
        return responseUpdate;
      } else {
        const dataSaveReservation = {
          ...data,
          patientId: response.data.id,
        };
        const responseReservation = await postBookingReservation(
          dataSaveReservation
        );

        return responseReservation;
      }
    } else {
      return response;
    }
  } catch (error) {
    return error;
  }
};

export const updateReservation = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/update-reservation`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const endVisitReservation = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/end-visit-reservation`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getDetailReservation = async (id) => {
  try {
    const response = await axios.get(
      `/lambda/v1/get-reservation-detail/${id}`
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getReservations = async (
  busines_id,
  reservation_date,
  doctor_id
) => {
  try {
    let link =
      `/lambda/v1/get-reservation-data?business_id=${busines_id}`;

    if (reservation_date)
      link = link.concat(`&reservation_date=${reservation_date}`);

    if (doctor_id) link = link.concat(`&doctor_id=${doctor_id}`);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

export const postTransferPatient = async (data) => {
  try {
    const response = await axios.post(
      `/lambda/v1/post-transfer-patient`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const putUpdateReservationStatus = async (data) => {
  try {
    const response = await axios.put(
      `/lambda/v1/update-reservation-status`,
      data
    );

    return response;
  } catch (error) {
    return error;
  }
};
